<template>
  <div class="ai-disease-prediction">
    <div class="blank-for-navigation-bar"></div>
    <!--stepbar-navigation-->
    <stepbar-navigation
      :current="current"
      :isDisplay="isDisplay"
      @toggleCurrent="toggleCurrent"
      v-if="current !== 0"
      class="stepbar"
    />

    <!-- ページのタイトル -->
    <header-title :title="inputItem" />

    <!-- 入力フォーム：タブ(current)の数値によって表示が切り替わる -->
    <div :class="{ 'input-form': current !== 0 }">
      <keep-alive>
        <div
          v-bind:is="inputForm"
          @increment="increment"
          @setModel="setModel"
          :class="{ 'note-margin': current === 0 }"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../../design/HeaderTitleSlot.vue";

// インプットフォーム
import UserInformationInput from "./AiDiseasePredictionUserInformationInput.vue";
import PhysicalInformationInput from "./AiDiseasePredictionPhysicalInformationInput.vue";
import FamilysMedicalHistoryInput from "./AiDiseasePredictionFamilysMedicalHistoryInput";
import BloodTestInput from "./AiDiseasePredictionBloodTestInput";
import LifestyleInput from "./AiDiseasePredictionLifestyleInput";
import Confirmation from "./AiDiseasePredictionConfirmation";

import Notes from "../../views/Notes";

import StepbarNavigation from "../../design/StepbarNavigation";

export default {
  data() {
    const $t = this.$t.bind(this);
    return {
      // 配列操作用の変数
      current: 0,
      currentDate: null,
      isDisplay: null,
      inputItems: [
        $t("notes.directions"),
        $t("yourInformation.yourInformation"),
        $t("yourPhysicalInformation.physicalInformation"),
        $t("yourFamilysMedicalHistory.aboutYourFamilysMedicalHistory"),
        $t("bloodTestResult.bloodTestResult"),
        $t("yourLifestyle.yourLifestyle"),
        $t("confirmation.confirmation"),
      ],
      inputForms: [
        "notes",
        "user-information",
        "physical-information",
        "family-medical-history",
        "blood-test",
        "lifestyle",
        "confirmation",
      ],
    };
  },
  components: {
    HeaderTitle,
    notes: Notes,
    "user-information": UserInformationInput,
    "physical-information": PhysicalInformationInput,
    "family-medical-history": FamilysMedicalHistoryInput,
    "blood-test": BloodTestInput,
    lifestyle: LifestyleInput,
    confirmation: Confirmation,
    StepbarNavigation,
  },
  created() {
    //スクロールの位置を初期化；　indexをページトップにする処理
    scrollTo(0, 0);
  },
  computed: {
    // currentに応じて、タイトルスロットの中身が書き換わる
    inputItem: function() {
      return this.inputItems[this.current];
    },
    inputForm: function() {
      return this.inputForms[this.current];
    },
  },
  methods: {
    // "つぎへ"のボタン押下時に発動するメソッド
    increment: function() {
      this.current = this.current + 1;
    },
    // ステップバーコンポーネントから受け取った数値を代入するメソッド
    toggleCurrent: function(num) {
      this.current = num;
    },
    handleResize() {
      let width = window.innerWidth;
      if (width > 960) {
        this.isDisplay = true;
      } else {
        this.isDisplay = false;
      }
    },
    // カルテデータの新規登録・更新
    setKarteData() {
      this.$store.dispatch("karte/sendKarteToFirebase", {
        uid: this.$store.state.auth.user.uid,
        date: this.currentDate,
        karteData: this.karteData,
      });
    },
    // カルテデータの削除
    deleteKarteData() {
      this.$store.dispatch(
        "karte/deleteKarteToFirebase",
        this.$store.state.auth.user.uid,
        this.currentDate
      );
    },

    setModel(data) {
      this.$store.dispatch("aiPrediction/setModel", data);
    },
  },
  mounted() {
    window.addEventListener("resize", _.debounce(this.handleResize), 500);
    if (window.innerWidth > 960) {
      this.isDisplay = true;
    } else {
      this.isDisplay = false;
    }
  },
  deforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.blank-for-navigation-bar {
  height: 60px;
}
.ai-disease-prediction {
  min-height: 100vh;
  align-content: center;
  margin: 0 auto;
}
.stepbar {
  align-content: center;
  margin: 0 auto;
}
/*
  注意事項コンポーネントはステップバーがないため、
  マージンを別で指定する
 */
.note-margin {
  margin-top: 20px;
}
.input-form {
  display: flex;
  justify-content: center;
  margin: auto;
  padding: 20px;
  border: 1px solid #d8e0e7;
  border-radius: 5px;
  width: 60vw;
}
@media screen and (max-width: 599px) {
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .stepbar {
    margin-top: 40px;
  }
  .note-margin {
    margin-top: 40px;
  }
  .input-form {
    padding: 40px;
  }
}
@media screen and (min-width: 960px) {
  .stepbar {
    margin-top: 40px;
  }
  .note-margin {
    margin-top: 40px;
  }
  .input-form {
    padding: 40px;
  }
}
</style>
